// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { QuickTableColumnType } from "../elements/QuickTable/QuickTableMisc.js";
import { BaseItem } from "./BaseItem.js";
import { ColumnParams } from "./ColumnParams.ts";

export let DefaultLotTableItem = function (selectiveLot, id)
{
    BaseItem.call(this, null)
    this.selectiveLot = selectiveLot
    this.ItemId = id
}
DefaultLotTableItem.prototype = Object.create(BaseItem.prototype)

DefaultLotTableItem.prototype.ColumnCount = function ()
{
    return DefaultLotTableItem.columnsParams.length
}

DefaultLotTableItem.prototype.GetColumnParams = function (column)
{
    return DefaultLotTableItem.columnsParams[column]
}

DefaultLotTableItem.prototype.getColumnData = function (column)
{
    let val = this.getColumnValue(column)
    return { Value: val, FormattedValue: val ? val.toString() : '' }
}

DefaultLotTableItem.prototype.getColumnValue = function (column)
{
    let selectiveLot = this.selectiveLot
    switch (column)
    {
        case 0:
            return selectiveLot.Selected
        case 1:
            return selectiveLot.Lots
        default:
            return null
    }
}

DefaultLotTableItem.columnsParams =
[
    new ColumnParams('TypesManagerScreen.QuickTable.Column.Enable',       80,  QuickTableColumnType.COL_BOOLEAN, false, true, false),
    new ColumnParams('TypesManagerScreen.QuickTable.Column.Default lots', 110, QuickTableColumnType.COL_DEFAULT, false, true, false)
]